import { Col, Row, Spinner } from "react-bootstrap"

const LoadingMask = () => {

    return (
        <div className="texxt-center">
            <Row>
                <Col xl="12">
                    <div className="animate__animated animate__backInRight">
                        <Spinner animation="border" className="text-energo" />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="text-center">
                    <h3 className="text-warning">Laden</h3>
                    <p className="text-muted mt-3">Daten werden geladen.</p>
                </Col>
            </Row>
        </div>
    )
}
export default LoadingMask;